module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/97816425039443#_idTextAnchor001"
    }
  }, [_vm._v("Adventure"), _c('span', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white _idGenParaOverride-1",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("When I was young, adventure meant going off with my sister or a group of friends to explore—whether that meant going to a mall and observing shoppers, biking to a faraway lake, or playing games in the woods behind our house. Today, not only does adventure mean being inspired by new experiences when I travel, but also being inspired by seeing everyday experiences with fresh eyes. It could be paying close attention to what I see on walks and hikes or even the thrilling experience of discovering something I love via online research.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cc53a2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97816425039447.vue
// module id = 81
// module chunks = 0